import React from 'react';
import './style.scss';
import { map } from 'lodash';
import { Link } from 'react-router-dom'

const BottomMenu = ({ menu_items }) => {
    return (
        <div className='bottom-menu'>
            {
                map(menu_items, item => (
                    <Link to={item.path} key={item.link_name} className='menu-item'>
                        {item.icon}
                        {item.link_name}
                    </Link>
                ))
            }
        </div>
    );
};

export default BottomMenu;